"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _identity = _interopRequireDefault(require("transmute/identity"));

var RichTextEditorConfigurationRecord = (0, _immutable.Record)({
  type: null,
  plugins: (0, _immutable.Seq)(),
  pluginComposers: (0, _immutable.Seq)(),
  composed: _identity.default,
  hasContent: null
});

var RichTextEditorConfiguration =
/*#__PURE__*/
function (_RichTextEditorConfig) {
  (0, _inherits2.default)(RichTextEditorConfiguration, _RichTextEditorConfig);

  function RichTextEditorConfiguration() {
    (0, _classCallCheck2.default)(this, RichTextEditorConfiguration);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RichTextEditorConfiguration).apply(this, arguments));
  }

  (0, _createClass2.default)(RichTextEditorConfiguration, [{
    key: "enhanceWith",
    value: function enhanceWith(name, additionalPlugins, additionalPluginComposers) {
      return this.merge({
        type: this.type + "-" + name,
        plugins: this.plugins.concat(additionalPlugins),
        pluginComposers: this.pluginComposers.concat(additionalPluginComposers)
      });
    }
  }, {
    key: "configureWith",
    value: function configureWith(composer) {
      var plugins = this.plugins.toArray();
      var pluginComposer;

      if (this.pluginComposers.size > 1) {
        pluginComposer = composer.apply(void 0, (0, _toConsumableArray2.default)(this.pluginComposers.toArray()));
      } else if (!this.pluginComposers.isEmpty()) {
        pluginComposer = this.pluginComposers.first();
      }

      if (pluginComposer) {
        plugins = [pluginComposer.apply(void 0, (0, _toConsumableArray2.default)(plugins))];
      }

      return this.set('composed', composer.apply(void 0, (0, _toConsumableArray2.default)(plugins)));
    }
  }]);
  return RichTextEditorConfiguration;
}(RichTextEditorConfigurationRecord);

exports.default = RichTextEditorConfiguration;
module.exports = exports.default;